// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const GoogleAccountDisconnected: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;
  const navigate = useNavigate();

  return (
    <Text>
      Der Zugriff auf dein Google Konto
      <Text span weight="bolder">
        {` ${value} `}
      </Text>
      muss aktualisiert werden.{'  '}
      <LinkText span weight="bolder" onClick={() => navigate(`/settings/google?reconnect=true`)}>
        Klick hier
      </LinkText>
      , um die Verbindung wieder herzustellen.
    </Text>
  );
};

export default GoogleAccountDisconnected;
